import { Box, Grid, Typography } from "@mui/material";

export const HeldTimesTab = ({ heldTimes }) => {
  return (
    <Grid sx={{ bgcolor: "#374151", p: 2, flex: 1 }}>
      {/* Summary rows */}
      <Box>
        {heldTimes.columnOne.map((row) => (
          <Box
            key={row.label}
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "start",
              py: 0.6,
              borderBottom: { xs: "1px solid #a0a0a0ff", md: "0px" },
              gap: 6,
            }}
          >
            <Typography
              sx={{ color: "#ffffffff", fontWeight: 600, fontSize: 13 }}
            >
              {row.label}
            </Typography>
            <Typography
              sx={{ color: "#c3daffff", fontWeight: 600, fontSize: 13 }}
            >
              {row.value}
            </Typography>
          </Box>
        ))}
      </Box>
      {/* Runs (2 columns of 12) */}
      <Grid
        container
        spacing={{ xs: 0, lg: 4 }}
        sx={{
          mt: 2,
        }}
      >
        <Grid size={{ xs: 12, md: 12, lg: 6 }}>
          {heldTimes.heldTimesLeft.map((run) => (
            <Box
              key={run.label}
              sx={{
                display: "flex",
                justifyContent: "space-between",
                py: 0.6,
                borderBottom: "1px solid #a0a0a0ff",
              }}
            >
              <Typography
                sx={{ color: "#ffffffff", fontWeight: 600, fontSize: 13 }}
              >
                {run.label}
              </Typography>
              <Typography
                sx={{ color: "#c3daffff", fontWeight: 600, fontSize: 13 }}
              >
                {run.value}
              </Typography>
            </Box>
          ))}
        </Grid>
        <Grid size={{ xs: 12, md: 12, lg: 6 }}>
          {heldTimes.heldTimesRight.map((run) => (
            <Box
              key={run.label}
              sx={{
                display: "flex",
                justifyContent: "space-between",
                py: 0.6,
                borderBottom: "1px solid #a0a0a0ff",
              }}
            >
              <Typography sx={{ color: "#ffffffff", fontSize: 13 }}>
                {run.label}
              </Typography>
              <Typography sx={{ color: "#c3daffff", fontSize: 13 }}>
                {run.value}
              </Typography>
            </Box>
          ))}
        </Grid>
      </Grid>
    </Grid>
  );
};
